export type Fase =
  | "grupos"
  | "dieciseisavos"
  | "octavos"
  | "cuartos"
  | "semifinal"
  | "final";

export const MULTIPLICADORES: Record<Fase, number> = {
  grupos: 8,
  dieciseisavos: 9,
  octavos: 10,
  cuartos: 11,
  semifinal: 15,
  final: 20,
};

export const PUNTOS_CAMPEON: Record<Fase, number> = {
  grupos: 2000,
  dieciseisavos: 1500,
  octavos: 1000,
  cuartos: 700,
  semifinal: 400,
  final: 200,
};

export function puntosCampeonPorFase(fase: Fase): number {
  return PUNTOS_CAMPEON[fase];
}

export type TipoPartido = "normal" | "tercer_puesto" | "final";

export const MULTIPLICADOR_TIPO: Record<TipoPartido, number> = {
  normal: 0,
  tercer_puesto: 15,
  final: 20,
};
